import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

var lng = localStorage.getItem("i18nextLng");

if (lng === 'pt-BR' || lng === 'en-US') {
  localStorage.setItem("i18nextLng", lng);
  lng = window.localStorage.i18nextLng;
} else {
  localStorage.setItem("i18nextLng", "pt-BR");
  lng = window.localStorage.i18nextLng;
}


i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `${process.env.REACT_APP_API_URL}/api/Location/Resource/${lng}`
    },
    debug: false,
    fallbackLng: 'pt-BR',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });



export default i18n;
